/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCollapsibleHeader/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TysiaCollapsibleHeader({
  children,
  viewPath = "/DesignSystem/TysiaCollapsible/TysiaCollapsibleHeader",
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  backgroundColor,
  borderBottomStyle,
  borderBottomWidth,
  borderBottomColor,
  alignItems,
  onToggle,
  isOpen,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="TysiaCollapsibleHeader.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onToggle}
 style={{'--pt-1-ZD6zhO': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-2-ZD6zhO': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-3-ZD6zhO': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-4-ZD6zhO': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--bc-5-ZD6zhO': backgroundColor,'--bbs-6-ZD6zhO': borderBottomStyle,'--bbw-7-ZD6zhO': typeof borderBottomWidth === 'number' ? `${borderBottomWidth}px` : borderBottomWidth,'--bbc-8-ZD6zhO': borderBottomColor,'--ai-9-ZD6zhO': alignItems}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isOpen={isOpen}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}